import { LoggerContract } from "../contracts/logger/logger";
import React, { useContext } from "react";
import { AnalyticsContract } from "../contracts/analytics/analytics";
import { RecurlyApiContract } from "../contracts/recurly-api/recurly-api";
import RecurlyApi from "../adapters/recurly-api/actual-api/recurly";
import { NexarApiContract } from "../contracts/nexar-api/nexar-api";
import NexarApi from "../adapters/nexar-api/actual-api/api";

export interface DIContainer {
  logger?: LoggerContract;
  analytics?: AnalyticsContract;
  nexarApi: NexarApiContract;
  recurlyApi: RecurlyApiContract;
}
const defaultValue: DIContainer = {
  nexarApi: NexarApi,
  recurlyApi: RecurlyApi,
};

const DIContext = React.createContext<DIContainer>(defaultValue);
export default DIContext;

export function useDI() {
  return useContext(DIContext);
}
